<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col md="12">
                    <ValidationProvider name="religious_exemption_text" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('detail')">
                            <b-form-textarea
                                id="textarea"
                                v-model="request_data.religious_exemption_text"
                                placeholder="Enter Details"
                                rows="6"
                                :disabled="isReadOnly"
                                max-rows="12"
                                :state="errors.length === 0"
                            ></b-form-textarea>
                            <span class="text-danger" v-if="errors.length">{{ errors[0] }}</span>

                        </b-form-group>

                    </ValidationProvider>
                </b-col>

                <b-col cols="12" class="mt-3" v-if="!isReadOnly">
                    <b-form-group :label="$t('file')">
                        <div class="d-flex custom-file-upload">
                            <b-form-file
                                v-model="request_data.file"
                                :placeholder="$t('select_file')"
                                :drop-placeholder="$t('drop_file')"
                                ref="fileInput"
                                multiple
                            ></b-form-file>
                            <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">
                                {{ $t('browse') }}
                            </b-button>
                        </div>
                        <div class="alert alert-info mt-2">{{ $t('warning_file2') }}</div>
                    </b-form-group>
                </b-col>

                <!-- Save Button -->
                <b-col cols="12" md="2" v-if="!isReadOnly">
                    <b-form-group class="mb-0">
                        <label class="d-none d-md-block">&nbsp;</label>
                        <b-button variant="primary" block @click="save">
                            {{ $t('save').toUpperCase() }}
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import StudentRequestService from '@/services/StudentRequestService';
import {EventBus} from "@/main";

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            request_data: {
                file: [],
            },
            formLoading: false,
        };
    },
    created() {
        this.request_data = this.data.request_data || {};
        this.request_data.file = [];
    },
    computed: {
        getReservationToken() {
            return this.$store.getters['roomReservationSystem/getReservationToken'];
        },
    },
    methods: {
        async save() {
            this.formLoading = true;
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                };
                const formData = new FormData();
                formData.append('request_type', 'religious_exemption');
                formData.append('housing_reservation_id', this.data.id);
                formData.append('request_data[religious_exemption_text]', this.request_data.religious_exemption_text);

                if (this.request_data.file && this.request_data.file.length > 0) {
                    this.request_data.file.forEach((file, index) => {
                        formData.append(`request_data[files][${index}]`, this.request_data.file[index]);
                    });
                }

                try {
                    const response = await StudentRequestService.studentRequest(formData, config);
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$router.push('/housing/request/list');
                } catch (error) {
                    EventBus.$emit('formClearRequest')
                    this.showErrors(error, this.$refs.formModalValidate);
                } finally {
                    this.formLoading = false;
                }
            } else {
                this.formLoading = false;
            }
        },
    },
};
</script>
